import { BlogPostEntity, BlogPostSchema, CommentEntity, CommentSchema } from 'mk2/apps/blogs/schemas';
import { Entity, UserEntity, UserSchema } from 'mk2/schemas';
import { schema } from 'normalizr';

export const deletionKey = (entity: string, id: number): string => `${entity}/${id}`;

export enum DeletionTargetType {
    PhotoblogComment = 'photoblog-comment',
    PhotoblogPost = 'photoblog-post',
}

export type DeletionTargetEntity = BlogPostEntity | CommentEntity;

interface UnionKey {
    schema: DeletionTargetType;
}

export interface DeletionEntity extends Entity {
    readonly user: UserEntity;
    readonly target: DeletionTargetEntity & UnionKey;
    readonly comment: string;
    readonly createdAt: string;
    readonly deletedAt: string;
}

const TargetSchema = new schema.Union({
    [DeletionTargetType.PhotoblogPost]: BlogPostSchema,
    [DeletionTargetType.PhotoblogComment]: CommentSchema,
}, 'target');

export const DeletionSchema = new schema.Entity('deletions', {
    user: UserSchema,
    target: TargetSchema,
});
